import React from 'react';
import { DateUtils } from '@vectord/utils';
import pluralize from 'pluralize';

import { LearnerInfoPopover } from 'features/courseResume';
import CoursePauseRequestApproveButton from '../CoursePauseRequestApproveButton';
import styles from './CoursePausePendingRequestsTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function CoursePausePendingRequestsTableRow({ coursePauseRequest }) {
  const {
    duration_of_pause: durationOfPause,
    pause_date: pauseDate,
    note,
    meta,
  } = coursePauseRequest;
  const { suggested_sb_name: suggestedSuperBatchName } = meta || {};

  return (
    <TableRow className={styles.root}>
      <TableCell className={styles.rowCell}>
        <LearnerInfoPopover request={coursePauseRequest} />
      </TableCell>
      <TableCell className={styles.rowCell}>
        {DateUtils.toDDMMYYYY(pauseDate)}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {pluralize('Month', durationOfPause, true)}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {suggestedSuperBatchName || 'N/A'}
      </TableCell>
      <TableCell className={styles.rowCell}>
        <div className={styles.noteContainer}>{note?.content || 'N/A'}</div>
      </TableCell>
      <TableCell className={styles.actionCell}>
        <CoursePauseRequestApproveButton
          coursePauseRequest={coursePauseRequest}
        />
      </TableCell>
    </TableRow>
  );
}

export default CoursePausePendingRequestsTableRow;
